
@if(currentOrganization()) {
  <router-outlet></router-outlet>
} @else {
  @for(organization of organizations(); track organization.id) {
    <div class="organization">
      <p>{{organization.name}}</p>
      <button (click)="createProject(organization.id)">+ Add project</button>
    </div>
  }
}

<!--<div class="organizations-page">-->
<!--  &lt;!&ndash; Loading State &ndash;&gt;-->
<!--  @if (organizations(); as organizations) {-->
<!--    @if (organizations.length === 0) {-->
<!--      &lt;!&ndash; Empty State &ndash;&gt;-->
<!--      <div class="empty-state">-->
<!--        <div class="empty-content">-->
<!--          <i class="ri-building-4-line"></i>-->
<!--          <h2>Welcome to Your Dashboard</h2>-->
<!--          <p>Get started by creating your first organization</p>-->
<!--          <button class="primary-button" [routerLink]="['/app/organizations/create']">-->
<!--            Create Organization-->
<!--          </button>-->
<!--        </div>-->
<!--      </div>-->
<!--    } @else {-->
<!--      @if (recentProjects().length > 0) {-->
<!--        <div class="buttons-gap">-->
<!--          <h2>Welcome back!</h2>-->
<!--          <button class="add-button" [routerLink]="['/app', 'organizations', 'create']">-->
<!--            <span class="material-icons">add</span>-->
<!--            New Organization-->
<!--          </button>-->
<!--        </div>-->
<!--        <div class="recent-projects">-->
<!--          @for (project of recentProjects(); track project.id) {-->
<!--            <div class="recent-project"-->
<!--                 [routerLink]="['/app', 'organizations', project.organization_id, 'projects', project.project_id]">-->
<!--              <p class="project-name">-->
<!--                {{ project.project_name }}-->
<!--              </p>-->
<!--              @if (organizations.length > 1) {-->
<!--                <p class="org-name">-->
<!--                  {{ project.organization_name }}-->
<!--                </p>-->
<!--              }-->
<!--            </div>-->
<!--          }-->
<!--        </div>-->
<!--      }-->

<!--      @if (organizations; as orgs) {-->
<!--        <div class="organizations-list">-->
<!--          @for (org of orgs; track org.id) {-->
<!--            @if (orgProjects(org.id)(); as projects) {-->
<!--              <div class="organization-header">-->
<!--                <h2>{{ org.name }} <span class="org-tier">({{ org.tier_id || 'Free' }} Plan)</span></h2>-->
<!--                <button class="add-button" (click)="createProject(org.id)">-->
<!--                  <span class="material-icons">add</span>-->
<!--                  New Project-->
<!--                </button>-->
<!--              </div>-->
<!--              @if (projects.length === 0) {-->
<!--                &lt;!&ndash; Empty State &ndash;&gt;-->
<!--                <div class="empty-state org">-->
<!--                  <div class="empty-content">-->
<!--                    <i class="ri-building-4-line"></i>-->
<!--                    <p>Create your first project in {{ org.name }}</p>-->
<!--                  </div>-->
<!--                </div>-->
<!--              } @else {-->
<!--                <div class="projects-list">-->
<!--                  @for (project of projects; track project.id) {-->
<!--                    <div class="project"-->
<!--                         [routerLink]="['/app', 'organizations', project.organization_id, 'projects', project.id]">-->
<!--                      <div class="organization-header">-->
<!--                        <div class="project-info">-->
<!--                          <div class="project-avatar">{{ project.name[0] }}</div>-->
<!--                          <div class="project-details">-->
<!--                            <h3>{{ project.name }}</h3>-->
<!--                            <span-->
<!--                              class="org-tier">{{ project.members?.length || 0 }}&nbsp;&nbsp;member{{ project.members?.length === 1 ? '' : 's' }}</span>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  }-->
<!--                </div>-->
<!--              }-->
<!--            }-->
<!--          }-->
<!--        </div>-->
<!--      }-->
<!--    }-->
<!--  } @else {-->
<!--    <div class="loading-state">-->
<!--      <div class="loading-spinner"></div>-->
<!--      <span>Loading organizations...</span>-->
<!--    </div>-->
<!--  }-->

<!--  &lt;!&ndash; Delete Confirmation Dialog &ndash;&gt;-->
<!--  @if (showDeleteDialog()) {-->
<!--    <div class="dialog-overlay" (click)="cancelDelete()">-->
<!--      <div class="dialog-content" (click)="$event.stopPropagation()">-->
<!--        <h3>Delete Organization?</h3>-->
<!--        <p>Are you sure you want to delete <strong>{{ orgToDelete()?.name }}</strong>?</p>-->

<!--        @if (deleteSummary()) {-->
<!--          <div class="delete-summary">-->
<!--            <p class="warning">This will delete:</p>-->
<!--            <ul>-->
<!--              <li>{{ deleteSummary().to_be_deleted.projects }} project(s)</li>-->
<!--              <li>{{ deleteSummary().to_be_deleted.organization_members }} organization member(s)</li>-->
<!--              <li>{{ deleteSummary().to_be_deleted.project_members }} project member(s)</li>-->
<!--              <li>{{ deleteSummary().to_be_deleted.organization_invites }} pending invite(s)</li>-->
<!--            </ul>-->
<!--            <p class="warning">This action cannot be undone.</p>-->
<!--          </div>-->
<!--        }-->

<!--        <div class="dialog-actions">-->
<!--          <button class="secondary-button" (click)="cancelDelete()">Cancel</button>-->
<!--          <button class="danger-button" (click)="confirmDelete()">Delete Organization</button>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  }-->

<!--</div>-->
